import React from 'react'
import AssemblingShiftsFilter from './AssemblingShiftsFilter'
import AssemblingShiftsTable from './AssemblingShiftsTable'
import { WorkShift } from '@@partner:types:app'
import { useFetchAllWorkShifts } from '@@partner:graphql/query/assemblerWorkShifts/allWorkShifts'
import { useGridHelper } from '@@partner:helpers/crud/grid'
import './AssemblingShiftsTableView.scss'

export interface AssemblingShiftsTableViewProps {
  onEditShift: (shift: WorkShift) => void
  onDeleteShift: (shift: WorkShift) => void
  onViewShift: (shift: WorkShift) => void
}

export default function AssemblingShiftsTableView ({
  onEditShift,
  onDeleteShift,
  onViewShift
}: AssemblingShiftsTableViewProps) {
  const { page, tableSort, filter, handlePageSelect, handleSortColumn, handleFilterChanged } =
    useGridHelper({
      defaultSortFieldName: 'ts_starting',
      defaultSortDirection: 0,
      defaultSortType: 'desc',
      defaultLimit: 20,
      defaultLimitOptions: [ 10, 20, 50, 100 ],
      defaultFilter: {}
    })

  const { workshifts, pageInfo, loadingWorkShifts, errorWorkShifts } = useFetchAllWorkShifts({
    pager: { page },
    sort: {
      direction: tableSort.direction,
      fieldName: tableSort.fieldName
    }
  })

  const shifts = workshifts || []

  return (
    <div className="assembling-shifts-table-view">
      <AssemblingShiftsFilter onFilterChanged={handleFilterChanged} />
      
      <AssemblingShiftsTable
        data={shifts}
        loading={loadingWorkShifts}
        error={errorWorkShifts}
        pageInfo={pageInfo}
        tableSort={tableSort}
        page={page}
        onSortColumn={handleSortColumn}
        onPageSelect={handlePageSelect}
        onEditShift={onEditShift}
        onDeleteShift={onDeleteShift}
        onViewShift={onViewShift}
      />
    </div>
  )
}